import { defineStore } from 'pinia';
import { computed } from 'vue';
import * as z from 'zod/v4-mini';
import { defineWorkspaceStateHydration } from '#layers/runtime/public';

const WorkspaceInfoResult = z.object({
	ai: z.object({
		enabled: z.boolean(),
	}),
});

/** The `/info` probe of a workspace runtime; the endpoint answers unenveloped. */
export const workspaceInfoHydration = defineWorkspaceStateHydration(async (runtime) => WorkspaceInfoResult.parse(await runtime.fetch('/info')), { empty: null });

export const useWorkspaceInfoStore = defineStore('workspace-info', () => {
	const { data: info, isRefreshing, refresh: refreshInfo } = workspaceInfoHydration.use();

	/** Re-probes the active runtime; a failed probe keeps the last known state. */
	async function refresh() {
		try {
			await refreshInfo();
		}
		catch (error) {
			console.warn('[useWorkspaceInfoStore] /info probe failed; keeping last known state', error);
		}
	}

	return {
		refresh,
		aiEnabled: computed(() => info.value?.ai.enabled === true),
		loading: isRefreshing,
	};
});
